import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { TEACHERS_STUDENT_PORTFOLIO_URL } from 'config/urls';
import { cutText } from 'utils';

import ProgressBar from 'pages/Teachers/StudentListV2/components/ProgressBar';
import { reverse } from 'utils/urls';

import styles from './styles.module.scss';

const StudentRow = ({ student }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const toggleRow = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const handleRowClick = (e) => {
    e.stopPropagation();
    history.push({
      pathname: reverse(TEACHERS_STUDENT_PORTFOLIO_URL, { id: student.id }),
      state: { from: location }
    });
  };

  return (
    <>
      <tr className={styles.mainRow} onClick={handleRowClick}>
        <td>{cutText({ text: student.name, char: 30 })}</td>
        <td>
          {student.is_expandable ? (
            <button className={styles.expandButton} onClick={toggleRow}>
              {cutText({ text: student.section_label, char: 30 })}
              <span
                className={isExpanded ? styles.chevronUp : styles.chevronDown}
              >
                ▼
              </span>
            </button>
          ) : (
            <span className={styles.sectionText}>
              {cutText({ text: student.section_label, char: 30 })}
            </span>
          )}
        </td>
        <td className={styles.lightText}>{student.recent_upload}</td>
        <td>
          <ProgressBar
            student={student}
            currentPoints={student.current_points}
            maxPoints={student.max_points}
          />
        </td>
      </tr>

      {student.is_expandable &&
        isExpanded &&
        student.assignments?.map((assignment) => (
          <tr
            key={assignment.id}
            className={styles.subRow}
            onClick={handleRowClick}
          >
            <td></td>
            <td className={styles.lightText}>{assignment.name}</td>
            <td className={styles.lightText}>{assignment.recent_upload}</td>
            <td>
              <ProgressBar
                student={student}
                currentPoints={assignment.current_points}
                maxPoints={assignment.max_points}
                isSubRow={true}
                handleRowClick={handleRowClick}
              />
            </td>
          </tr>
        ))}
    </>
  );
};

export default StudentRow;
